import React, { FC } from 'react'

type IconProps = {
  className?: string
  size?: number
}

export const ArrowToLineIcon: FC<IconProps> = ({ className, size }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      style={{ transform: 'translateY(3px)' }} // tweak this number as needed
      viewBox={'0 0 20 20'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <g id={'arrow-to-line-group'}>
        <path
          d={
            'M4.75 3H15.25C15.6562 3 16 3.34375 16 3.75C16 4.1875 15.6562 4.5 15.25 4.5H4.75C4.3125 4.5 4 4.1875 4 3.75C4 3.34375 4.3125 3 4.75 3ZM10.5312 7.25L14.5312 11.5C14.8125 11.8125 14.8125 12.2812 14.5 12.5625C14.1875 12.8438 13.7188 12.8438 13.4375 12.5312L10.75 9.65625V16.25C10.75 16.6875 10.4062 17 10 17C9.5625 17 9.25 16.6875 9.25 16.25V9.65625L6.53125 12.5312C6.25 12.8438 5.78125 12.8438 5.46875 12.5625C5.15625 12.2812 5.15625 11.8125 5.4375 11.5L9.4375 7.25C9.59375 7.09375 9.78125 7 10 7C10.1875 7 10.4062 7.09375 10.5312 7.25Z'
          }
          fill={'currentColor'}
          id={'icon path'}
        />
      </g>
    </svg>
  )
}
